module.exports = __webpack_public_path__ + "img/monitorbox23.5c1fc715.jpg";